/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const DeviceGroupType = {
    Gateway: 'Gateway',
    PaymentTerminal: 'PaymentTerminal'
} as const;
export type DeviceGroupType = typeof DeviceGroupType[keyof typeof DeviceGroupType];

